<h2 mat-dialog-title>{{ 'orderHistory.orderGroupHistory' | transloco: { id: order.orderGroup!.id } }}</h2>
<mat-dialog-content>
    <table mat-table matSort [dataSource]="orderHistory" multiTemplateDataRows class="mat-elevation-z2">
        <ng-container matColumnDef="reference">
            <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.refNo' | transloco }} </th>
            <td mat-cell *matCellDef="let history"> {{ history.referenceNumber }} </td>
        </ng-container>

        <ng-container matColumnDef="orderTypeID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header id="orderTypeID"> {{ 'common.labels.type' | transloco }} </th>
            <td mat-cell *matCellDef="let order"> {{ order.orderTypeID | enumLabel:'orderType' }} </td>
        </ng-container>

        <ng-container matColumnDef="orderStatusTypeID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header id="orderStatusTypeID"> {{ 'common.labels.status' | transloco }}
            </th>
            <td mat-cell *matCellDef="let order"> {{ order.orderStatusTypeID | enumLabel:'orderStatusType' }} </td>
        </ng-container>

        <ng-container matColumnDef="country">
            <th mat-header-cell *matHeaderCellDef mat-sort-header id="country"> {{ 'common.labels.country' | transloco }} </th>
            <td mat-cell *matCellDef="let order"> {{order.country}} </td>
        </ng-container>

        <ng-container matColumnDef="jurisdiction">
            <th mat-header-cell *matHeaderCellDef mat-sort-header id="jurisdiction"> {{ 'common.labels.jurisdiction' | transloco }}
            </th>
            <td mat-cell *matCellDef="let order"> {{order.displayJurisdiction}} </td>
        </ng-container>

        <ng-container matColumnDef="dateRequested">
            <th mat-header-cell *matHeaderCellDef mat-sort-header id="dateRequested"> {{ 'common.labels.dateRequested' | transloco }}
            </th>
            <td mat-cell *matCellDef="let order">
                {{order.dateRequested | localizedDate }}
            </td>
        </ng-container>

        <ng-container matColumnDef="dateUpdated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header id="dateUpdated"> {{ 'orderHistory.dateUpdated' | transloco }}
            </th>
            <td mat-cell *matCellDef="let order">
                {{order.orderStatusUpdatedDate | localizedDate }}
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'grey': row.id == order.id}"
            tabindex="0" (click)="navigateToOrder(row.id)" (keydown.enter)="navigateToOrder(row.id)">
        </tr>
    </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.close' | transloco }}</button>
</mat-dialog-actions>